import {AutoMap} from '@automapper/classes';
import {TCommonModel} from './common/t-common-model';

export class UserLocalDataModel extends TCommonModel {
  @AutoMap()
  public firstName!: string

  @AutoMap()
  public lastName!: string | null

  @AutoMap()
  public email!: string

  @AutoMap()
  public accessToken!: string

  @AutoMap()
  public refreshToken!: string
}
